
//App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./index.css"; // Tailwind import
import "./print.css";


import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";



import NotificationsPanel from "./components/NotificationsPanel";
import { AuthProvider } from "./context/AuthContext";
import { useAuth } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useLocation } from "react-router-dom";
import TopNav from "./components/TopNav";
import Profile from "./pages/Profile";

import StaffRegistrationFullPage from "./pages/forms/StaffRegistrationFullPage";
import StaffRegistrationShortPage from "./pages/forms/StaffRegistrationShortPage";
import NotificationsPage from "./pages/staff/NotificationsPage";
import useUnreadNotifications from "./hooks/useUnreadNotifications";

import StaffChecklist from "./pages/staff/StaffChecklist";
import ShiftDetails from "./pages/staff/ShiftDetails";
import EditProfile from "./pages/EditProfile";





import AdminDashboard from "./pages/AdminDashboard";

import ShiftsEditor from "./pages/admin/ShiftsEditor";
import TimesheetManager from "./pages/admin/TimesheetManager";
import InvoiceManager from "./pages/admin/InvoiceManager";
import ClientTaskEditor from "./pages/admin/ClientTaskEditor";
import RotaEditor from "./pages/admin/RotaEditor";
import UserManagement from "./pages/admin/UserManagement";
import Reports from "./pages/admin/Reports";
import Plans from "./pages/admin/Plans";
import Clients from "./pages/admin/Clients";
import ClientDetails from "./pages/admin/ClientDetails";
import ShiftManager from "./pages/admin/ShiftManager";
import AdminComplianceTable from "./pages/admin/AdminComplianceTable";
import AdminFormReviewPage from "./pages/admin/AdminFormReviewPage";
import NewStarterPayrollAdminReview from "./pages/admin/forms/NewStarterPayrollAdminReview";
import ClientEdit from "./pages/admin/ClientEdit";
import ManualTimesheetCreator from "./pages/admin/ManualTimesheetCreator";
import ShiftStatusManager from "./pages/admin/ShiftStatusManager"; // Adjust the path based on your folder structure





import MyShifts from "./pages/staff/MyShifts";
import MyTimesheetsPayslips from "./pages/staff/MyTimesheetsPayslips";
import Chat from "./pages/staff/Chat";
import ContactUs from "./pages/staff/ContactUs";
import RegistrationAndDocuments from "./pages/staff/RegistrationAndDocuments";
import SearchJobs from "./pages/staff/SearchJobs";
import ReferFriend from "./pages/staff/ReferFriend";
import NewStarterPayrollPage from "./pages/forms/NewStarterPayrollPage";






// Ensure default admin exists
const defaultAdmin = {
  name: "Admin User",
  email: "admin@convalesce.com",
  password: "Admin123!",
  role: "admin"
};

const users = JSON.parse(localStorage.getItem("users") || "[]");
const adminExists = users.some(u => u.email === defaultAdmin.email);

if (!adminExists) {
  users.push(defaultAdmin);
  localStorage.setItem("users", JSON.stringify(users));
  console.log("✅ Default admin account created");
}



// --- Pages ---
function Login() {
  const { login } = useAuth();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  

 const handleLogin = async () => {
  const success = await login(email, password);

  if (success) {
    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

    if (loggedInUser?.role === "admin") {
      window.location.href = "/admin-dashboard"; // redirect admin
    } else {
      window.location.href = "/home"; // redirect normal user
    }
  } else {
    setError("Invalid email or password.");
  }
};


const handleForgotPassword = async () => {
  try {
    const targetEmail =
      (email || "").trim() || window.prompt("Enter your email to reset password:");

    if (!targetEmail) return;

    await sendPasswordResetEmail(auth, targetEmail.trim());
    alert("Password reset email sent. Please check your inbox (and spam/junk).");
  } catch (err) {
    console.error("❌ Password reset error:", err);

    // Friendly messages
    const code = err?.code || "";
    if (code === "auth/user-not-found") {
      alert("No account found with that email.");
    } else if (code === "auth/invalid-email") {
      alert("Please enter a valid email address.");
    } else {
      alert("Could not send reset email. Please try again.");
    }
  }
};


  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-6">
      <div className="flex flex-col items-center mb-6">
        <div
          style={{ borderColor: "#9ca3af", borderWidth: "2px" }}
          className="p-4  rounded-full flex items-center justify-center shadow-md"
        >
          <img
            src={require("./assets/logo.png")}
            alt="Convalesce Logo"
            className="w-12 h-12 rounded-full object-cover"
          />
        </div>

        <h1 className="text-3xl font-bold mt-4 text-gray-500 font-mono">
          Convalesce
        </h1>
        <p className="text-gray-600 text-sm">Your comfort, your choice, your care.</p>
      </div>

      <div className="w-full max-w-sm bg-white p-6 rounded-2xl shadow-md">
        <input
          type="text"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-3 p-3 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 p-3 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
		{error && <p className="text-red-500 text-sm mb-2">{error}</p>}
        <button
          onClick={handleLogin}
          style={{ backgroundColor: "#4b5563" }}
          className="block text-center w-full text-white px-6 py-3 rounded-lg shadow hover:bg-gray-700 transition"
        >
          Login
        </button>
		
		
		<button
		  type="button"
		  onClick={handleForgotPassword}
		  className="mt-3 w-full text-sm text-blue-600 font-medium hover:underline">
		  Forgot password?
		</button>

		

        <p className="text-center text-sm text-gray-500 mt-4">
          Don’t have an account?{" "}
          <Link to="/signup" className="text-blue-600 font-medium hover:underline">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
}

function SignUp() {
  const { signUp } = useAuth();
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleSubmit = async () => {
    if (!name || !email || !password) {
      alert("Please fill all fields");
      return;
    }

    const success = await signUp({ name, email, password }); // ✅ now async/await

    if (success) {
      alert("Signed up successfully! Please log in.");
      window.location.href = "/"; // redirect to login
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-6">
      <div className="w-full max-w-sm bg-white p-6 rounded-2xl shadow-md">
        <h2 className="text-xl font-semibold mb-4">Sign Up</h2>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="mb-3 p-3 border rounded-lg w-full"
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-3 p-3 border rounded-lg w-full"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 p-3 border rounded-lg w-full"
        />
        <button
          onClick={handleSubmit}
          style={{ backgroundColor: "#4b5563" }}
          className="w-full text-white py-3 rounded-lg hover:bg-gray-600 transition"
        >
          Sign Up
        </button>
        <p className="text-center text-gray-500 mt-4 text-sm">
          Already have an account?{" "}
          <a href="/" className="text-blue-600 font-medium hover:underline">
            Log In
          </a>
        </p>
      </div>
    </div>
  );
}




function Home() {
  const { user } = useAuth(); 	
  const cards = [
    { title: "Registration & Documents", path: "/registration", img: "https://img.icons8.com/ios-filled/100/f43f5e/document.png", roles: ["user","admin"] },
    { title: "Availability & Shifts", path: "/availability", img: "https://img.icons8.com/ios-filled/100/4b5563/calendar.png", roles: ["user","admin"] },
	{ title: "Timesheets & Payslips", path: "/timesheet", img: "https://img.icons8.com/ios-filled/100/4b5563/task.png", roles: ["user","admin"] },
    { title: "Chat", path: "/chat", img: "https://img.icons8.com/ios-filled/100/f43f5e/chat.png", roles: ["user","admin"] },
    { title: "Contact Us", path: "/contact", img: "https://img.icons8.com/ios-filled/100/f43f5e/phone.png", roles: ["user","admin"] },
    { title: "Search Jobs", path: "/jobs", img: "https://img.icons8.com/ios-filled/100/4b5563/search--v1.png", roles: ["user","admin"] },
    { title: "Refer a Friend", path: "/refer", img: "https://img.icons8.com/ios-filled/100/4b5563/add-user-group-man-man.png", roles: ["user","admin"] },
	{ title: "Admin Panel", path: "/admin-dashboard", img: "https://img.icons8.com/ios-filled/100/f43f5e/administrator-male.png", roles: ["admin"] },
    { title: "Invoices", path: "/admin/invoices", img: "https://img.icons8.com/ios-filled/100/f43f5e/invoice.png", roles: ["admin"], allowedEmails: ["jkaye@convalesceuk.com"] }

  ];

  return (
    <div style={{ paddingTop: "30px", }}
	className="flex flex-col items-center p-4 space-y-4 text-gray-500">
      <h2 className="text-xl text-gray-500 font-semibold mb-2">Welcome to Convalesce</h2>
      <div className="grid grid-cols-2 gap-4 w-full max-w-md">
        {cards
  .filter(card => {
    const email = (user?.email || "").toLowerCase();

    const roleAllowed = (card.roles || []).includes(user.role);
    const emailAllowed = (card.allowedEmails || [])
      .map(e => e.toLowerCase())
      .includes(email);

    return roleAllowed || emailAllowed;
  })
  .map((card) => (

          <Link
            to={card.path}
            key={card.title}
            className="bg-white p-6 shadow rounded-2xl text-center hover:shadow-lg transition flex flex-col items-center"
          >
            <img src={card.img} alt={card.title} className="w-12 h-12 mb-3 text-gray-500" />
            <span className="text-sm font-medium text-gray-700">{card.title}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

// Placeholder pages

function AvailabilityPlaceholder() { return <Page title="Availability & Shifts" />; }
function Timesheets() { return <Page title="Timesheets & Payslips" />; }
function Admin() { return <Page title="Admin Panel" />; }


function Page({ title }) {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold">{title}</h1>
    </div>
  );
}


// --- Add this new component for Shifts ---
function Shifts() {
  const shifts = [
    {
      name: "Toby Shaw",
      location: "20c Church road Bookham KT23 3PW",
      time: "10:00 - 15:00",
	  duration: "5hrs",
	  days: "Mon",
	  rate: "£13"
    },
    {
      name: "Akash Smith",
      location: "Manchester",
      time: "08:00 - 16:00",
      days: "Tue, Thu",
    },
    // add more shifts here
  ];

  return (
    <div className="p-6 max-w-md mx-auto space-y-6">
      <h1 className="text-2xl font-bold mb-4">Available Shifts</h1>
      {shifts.map((shift, index) => (
        <div key={index} className="bg-white p-4 rounded-2xl shadow-md space-y-1">
          <p><strong>Name:</strong> {shift.name}</p>
          <p><strong>Location:</strong> {shift.location}</p>
          <p><strong>Time:</strong> {shift.time}</p>
		  <p><strong>Duration:</strong> {shift.duration}</p>
          <p><strong>Shift days:</strong> {shift.days}</p>
          <p><strong>Rate/hr:</strong> {shift.rate}</p>
		  <p><strong>Support worker:</strong> Call Agency</p>
        </div>
      ))}
    </div>
  );
}








// --- Add this placeholder for the actual Availability details page ---
function AvailabilityForm() {
  const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const [availability, setAvailability] = React.useState(
    daysOfWeek.reduce(
      (acc, day) => ({ ...acc, [day]: { start: "", end: "", selected: false } }),
      {}
    )
  );

  const toggleDay = (day) => {
    setAvailability({
      ...availability,
      [day]: { ...availability[day], selected: !availability[day].selected },
    });
  };

  const handleTimeChange = (day, field, value) => {
    setAvailability({
      ...availability,
      [day]: { ...availability[day], [field]: value },
    });
  };

  return (
    <div className="p-6 max-w-lg mx-auto space-y-6">
      <h1 className="text-2xl font-bold mb-4">Set Your Availability</h1>

      {daysOfWeek.map((day) => (
        <div key={day} className="flex items-center space-x-4">
          <input
            type="checkbox"
            checked={availability[day].selected}
            onChange={() => toggleDay(day)}
            className="w-5 h-5"
          />
          <span className="w-12">{day}</span>
          <input
            type="time"
            value={availability[day].start}
            onChange={(e) => handleTimeChange(day, "start", e.target.value)}
            disabled={!availability[day].selected}
            className="border rounded px-2 py-1 w-24"
          />
          <span>to</span>
          <input
            type="time"
            value={availability[day].end}
            onChange={(e) => handleTimeChange(day, "end", e.target.value)}
            disabled={!availability[day].selected}
            className="border rounded px-2 py-1 w-24"
          />
        </div>
      ))}

      <h2 className="text-xl font-semibold mt-6">Your Calendar</h2>
      <div className="grid grid-cols-7 gap-2 mt-2">
        {daysOfWeek.map((day) => (
          <div
            key={day}
            className={`p-2 border rounded text-center ${
              availability[day].selected ? "bg-green-200" : "bg-gray-100"
            }`}
          >
            <div className="font-bold">{day}</div>
            <div className="text-sm">
              {availability[day].selected
                ? `${availability[day].start || "--:--"} - ${
                    availability[day].end || "--:--"
                  }`
                : "Unavailable"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}






// --- Bottom Navigation ---
function BottomNav() {
  const location = useLocation();
  const { user } = useAuth();         // <-- FIX 1: Get user here
  const unread = useUnreadNotifications(user?.email); // <-- FIX 2: Hook now valid

  // Hide BottomNav on login and signup (AFTER hooks)
  if (location.pathname === "/" || location.pathname === "/signup") {
    return null;
  }

  return (
    <>
      {/* Footer text above */}
      <div
	    className="no-print"
        style={{
          textAlign: "center",
          color: "#9ca3af",
          marginTop: "30px",
          fontSize: "13px",
          paddingBottom: "5px",
        }}
      >
        <p>
          © {new Date().getFullYear()} Convalesce Care & Recruitment Ltd-UK.
          <br />
          <span style={{ color: "#d1d5db" }}>
            Your comfort, your choice, your care.
          </span>
        </p>
      </div>

      {/* Bottom nav bar */}
      <div
        style={{ backgroundColor: "#f43f5e" }}
        className="fixed bottom-0 left-0 w-full text-white flex justify-around p-3 text-sm"
      >
        <a href="tel:+447599121308" className="hover:underline">
          Call
        </a>

        {/* MESSAGES BUTTON WITH BADGE */}
        <Link to="/notifications" className="hover:underline relative">
          Messages
          {unread > 0 && (
            <span className="absolute -top-2 -right-4 bg-white text-red-600 text-xs px-2 py-1 rounded-full shadow">
              {unread}
            </span>
          )}
        </Link>

        <Link to="/home" className="hover:underline">
          Settings
        </Link>
      </div>
    </>
  );
}




// --- App Component ---
export default function App() {
  return (
    <Router>
      <AuthProvider>
		<TopNav />
			<div className="pt-16 pb-20">
			  <Routes>
				<Route path="/" element={<Login />} />
				<Route path="/signup" element={<SignUp />} />
				<Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
				
				{/* Staff routes */}
				<Route path="/registration" element={<ProtectedRoute><RegistrationAndDocuments /></ProtectedRoute>} />
				<Route path="/availability" element={<ProtectedRoute><MyShifts /></ProtectedRoute>} />
				<Route path="/timesheet" element={<ProtectedRoute><MyTimesheetsPayslips /></ProtectedRoute>} />
				<Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
				<Route path="/contact" element={<ProtectedRoute><ContactUs /></ProtectedRoute>} />
				<Route path="/jobs" element={<ProtectedRoute><SearchJobs /></ProtectedRoute>} />
				<Route path="/refer" element={<ProtectedRoute><ReferFriend /></ProtectedRoute>} />
				<Route path="/availability-form" element={<ProtectedRoute><AvailabilityForm /></ProtectedRoute>} />
				<Route path="/shifts" element={<ProtectedRoute><Shifts /></ProtectedRoute>} />
				<Route path="/admin-dashboard"  element={<ProtectedRoute adminOnly={true}> <AdminDashboard /></ProtectedRoute>} />
				{/* Admin routes */}
				<Route path="/admin/shifts" element={<ProtectedRoute><ShiftsEditor /></ProtectedRoute>} />
				<Route path="/admin/timesheets" element={<ProtectedRoute><TimesheetManager /></ProtectedRoute>} />
				<Route path="/admin/invoices" element={<ProtectedRoute adminOnly allowedEmails={["jkaye@convalesceuk.com"]}><InvoiceManager /></ProtectedRoute>} />
        <Route path="/admin/shift-status" element={<ProtectedRoute><ShiftStatusManager /></ProtectedRoute>} />
				<Route
  path="/admin/checklists/:clientId"
  element={
    <ProtectedRoute>
      <ClientTaskEditor />
    </ProtectedRoute>
  }
/>

				<Route path="/admin/rota" element={<ProtectedRoute><RotaEditor /></ProtectedRoute>} />
				<Route path="/admin/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
				<Route path="/admin/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
				<Route path="/admin/plans" element={<ProtectedRoute><Plans /></ProtectedRoute>} />
				<Route path="/admin/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
				<Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
				<Route path="/admin/clients/:id" element={<ProtectedRoute><ClientDetails /></ProtectedRoute>} />
				<Route path="/admin/compliance" element={<ProtectedRoute><AdminComplianceTable /></ProtectedRoute>} />
				<Route path="/admin/shifts" element={<ProtectedRoute><ShiftManager /></ProtectedRoute>} />
				<Route path="/forms/new-starter-payroll" element={<ProtectedRoute><NewStarterPayrollPage /></ProtectedRoute>} />
				<Route path="/forms/staff-registration-full" element={<ProtectedRoute><StaffRegistrationFullPage /></ProtectedRoute>} />
				<Route path="/forms/staff-registration-short" element={<ProtectedRoute><StaffRegistrationShortPage /></ProtectedRoute>} />
				<Route path="/admin/forms/:userId/:docId" element={ <ProtectedRoute adminOnly={true}> <AdminFormReviewPage /></ProtectedRoute>} />
				<Route path="/admin/forms/:userId/:docId" element={ <ProtectedRoute adminOnly={true}> <NewStarterPayrollAdminReview /></ProtectedRoute>} />
				<Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>}/>
				<Route path="/profile/edit" element={<EditProfile />} />

				<Route
  path="/staff/checklist/:shiftId"
  element={
    <ProtectedRoute>
      <StaffChecklist />
    </ProtectedRoute>
  }
/>

<Route 
  path="/staff/shifts/:shiftId"
  element={
    <ProtectedRoute>
      <ShiftDetails />
    </ProtectedRoute>
  }
/>


<Route
  path="/admin/manual-timesheet"
  element={
    <ProtectedRoute>
      <ManualTimesheetCreator />
    </ProtectedRoute>
  }
/>



				

				  
				  
				


				

				



			</Routes>
          <BottomNav />
        </div>
      </AuthProvider>
    </Router>
  );
}
